module.exports = __webpack_public_path__ + "img/ide-loop.46d640b2.svg";